import { compose, partial } from 'underscore';
import { enableById, disableById } from 'body-scroll-manager';

import {
  hide as doHide,
  setTitle as doSetTitle,
  show as doShow,
  set,
} from './duck';

const { store } = window.reduxState;

const show = () => {
  disableById('right-sidebar-scrollable');

  store.dispatch(doShow());
};

export const hide = () => {
  enableById('right-sidebar-scrollable');

  store.dispatch(doHide());
};

export const setTitle = compose(store.dispatch, doSetTitle);

export const setComponent = compose(store.dispatch, set);

export const showComponent = compose(show, setComponent);
export const showBetslip = partial(showComponent, 'betslip');
export const showCashout = partial(showComponent, 'cashout');
